export default __webpack_public_path__ + "dcd35e783722d6a3ed5aef6eaf025710.svg";